import { EmptyAppointmentQueryPropsFactory, IAppointmentProps, IAppointmentQueryProps } from '@/entities/Appointment'
import { EmptyResponsePropsFactory, IResponseProps } from '@/entities/Response'

export interface IScheduleState {
  response: IResponseProps<IAppointmentProps>
  current: IAppointmentProps | null
  query: IAppointmentQueryProps
  type: string | null
  scrollTop: number
  count: number
}

export const state = (): IScheduleState => ({
  response: EmptyResponsePropsFactory(),
  current: null,
  query: EmptyAppointmentQueryPropsFactory(),
  type: null,
  scrollTop: 0,
  count: 0
})

export default state
